

import { defineComponent } from 'vue';
import { mapState } from 'pinia'

import { useConfigStore } from '~/store/configuration.store';

export default defineComponent({
    data() {
        return {
            logo: require('@/elichens-logo.svg').default,
        };
    },
    computed: {
        ...mapState(useConfigStore, ['VERSION']),
        year() {
            return new Date().getFullYear();
        },
    },
});
